import { cloneElement, useCallback } from "react";

function useRenderIcon() {
  const renderIcon = useCallback((icon, defaultClassName) => {
    if (!icon) return null;
    const className = icon.props.className || `icon ${defaultClassName}`;
    return cloneElement(icon, { className });
  }, []);
  return renderIcon;
}

export default useRenderIcon;
